import(/* webpackMode: "eager", webpackExports: ["ChannelDetailPage"] */ "/vercel/path0/components/channels/ChannelDetailPage.tsx");
